import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_17: FaireProductEntity = {
  token: "catalog_prod_prod-17",
  type: "product",
  name: "Mini Pillows - Celebrate (3 Styles) - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 18.03,
  msrpDollars: 45.08,
  sku: "CO0017",
  caseSize: 12,
  material: "Linen",
  collectionToken: "col_confetti-cake",
  categoryTokens: ["catalog_cat_bath"],
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 384,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
